export type ModeType = "EDIT" | "VIEW"

// Enum in pathwright-blocks-server
export const BLOCKS_MODE = {
  EDIT: "EDIT",
  VIEW: "VIEW"
}
